import {
  CustomerEnvironment,
  CustomerEnvironmentId,
} from "./CustomerEnvironment";
import { IllegalStateError } from "shared-ts-utils-core";

export const resolveCustomerEnvironment = (args: {
  environments: Array<CustomerEnvironment>;
  previousChosenEnvironment: CustomerEnvironmentId | undefined;
}): CustomerEnvironmentId => {
  if (args.environments.length === 0) {
    throw new IllegalStateError("No environments available");
  }

  if (args.previousChosenEnvironment == null) {
    return args.environments[0].id;
  }
  let result = args.environments.find(
    (it) => it.id === args.previousChosenEnvironment
  )?.id;

  if (result == null) {
    result = args.environments[0].id;
  }
  return result;
};
